/*
 * Mailchimp
 */

const mailInput = document.querySelector('.js-mail-input');
const mailInputMC = document.querySelector('.js-mailchimp #mce-EMAIL');
const firstNameInput = document.querySelector('.js-first-name');
const firstNameInputMC = document.querySelector('.js-mailchimp #mce-FNAME');
const lastNameInput = document.querySelector('.js-last-name');
const lastNameInputMC = document.querySelector('.js-mailchimp #mce-LNAME');
const streetAddressInput = document.querySelector('.js-street-address');
const streetAddressInputMC = document.querySelector(
  '.js-mailchimp #mce-ADDRESS-addr1'
);
const streetAddressInput2 = document.querySelector('.js-street-address-2');
const streetAddressInputMC2 = document.querySelector(
  '.js-mailchimp #mce-ADDRESS-addr2'
);
const cityInput = document.querySelector('.js-city');
const cityInputMC = document.querySelector('.js-mailchimp #mce-ADDRESS-city');
const stateInput = document.querySelector('.js-state');
const stateInputMC = document.querySelector('.js-mailchimp #mce-ADDRESS-state');
const zipCodeInput = document.querySelector('.js-zip-code');
const zipCodeInputMC = document.querySelector('.js-mailchimp #mce-ADDRESS-zip');
const countrySelect = document.querySelector('.js-country-select');
const countrySelectMC = document.querySelector(
  '.js-mailchimp #mce-ADDRESS-country'
);
const popupSubmitMail = document.querySelector('.js-submit-first-popup');
const popupSubmit = document.querySelector('.js-submit-btn-mc');
const subscribeForm = document.querySelector('.js-subscribe-form');
const popupSubscribe = document.querySelector('.js-popup-subscribe');

mailInput?.addEventListener('input', (event) => {
  mailInputMC.value = event.target.value;
});

firstNameInput?.addEventListener('input', (event) => {
  firstNameInputMC.value = event.target.value;
});

lastNameInput?.addEventListener('input', (event) => {
  lastNameInputMC.value = event.target.value;
});

streetAddressInput?.addEventListener('input', (event) => {
  streetAddressInputMC.value = event.target.value;
});

streetAddressInput2?.addEventListener('input', (event) => {
  streetAddressInputMC2.value = event.target.value;
});

cityInput?.addEventListener('input', (event) => {
  cityInputMC.value = event.target.value;
});

stateInput?.addEventListener('input', (event) => {
  stateInputMC.value = event.target.value;
});

zipCodeInput?.addEventListener('input', (event) => {
  zipCodeInputMC.value = event.target.value;
});

countrySelect?.addEventListener('change', (event) => {
  countrySelectMC.value = event.target.value;
});

subscribeForm?.addEventListener('submit', function (event) {
  const isValidForm = subscribeForm.checkValidity();
  event.preventDefault();

  if (!isValidForm) {
    subscribeForm.reportValidity();
  }
});

popupSubmit?.addEventListener('click', function (event) {
  const isValidForm = subscribeForm.checkValidity();

  if (isValidForm) {
    event.preventDefault();

    submitMailchimpForm();
  }
});

const submitFirstPopup = document.querySelector('.js-submit-first-popup');
const modalContentFirst = document.querySelector('.js-modal-content-first');
const modalContentSecond = document.querySelector('.js-modal-content-second');

submitFirstPopup?.addEventListener('click', function (event) {
  const isValidMailInput = mailInput.checkValidity();

  if (!isValidMailInput) {
    mailInput.reportValidity();
  } else {
    submitMailchimpForm(true);
    modalContentFirst.classList.toggle('is-active');
    modalContentSecond.classList.toggle('is-active');
  }
});

/**
 * Submit mailchimp form.
 *
 * @param {Boolean} firstStep - is first step submit?
 * @returns {Void}
 */
const submitMailchimpForm = (firstStep = false) => {
  const $mailchimpForm = $('.js-mailchimp form');
  const serialize = $mailchimpForm.serialize();
  const action = $mailchimpForm
    .attr('action')
    .replace('post?u=', 'post-json?u=');
  const $errorHolder = $mailchimpForm.find('[id$="mce-error-response"]');
  const $successHolder = $mailchimpForm.find('[id$="mce-success-response"]');
  const $errorMessage = $('.subscribe__error');
  const $wrapper = $('.subscribe__message');
  const $successMessage = $('.subscribe__success');
  const $successBody = $('.subscribe__body');
  const $successActionsSubmit = $('.subscribe__btn-submit');
  const $successActionsClose = $('.subscribe__btn-close');
  const $mailError = document.querySelectorAll('#mce-EMAIL');
  const $mailErrorValue = $mailError[0].value.length;

  if ($mailErrorValue !== 0) {
    $.ajax({
      url: action,
      type: $mailchimpForm.attr('method'),
      dataType: 'jsonp',
      jsonp: 'c',
      data: serialize,
    }).done(function (data) {
      if (firstStep) {
        return;
      }

      if (data.result === 'error') {
        $errorHolder.show().html(data.msg.replace(/^\d\s-\s/g, ''));
        $errorMessage.html(data.msg.replace(/^\d\s-\s/g, ''));
        $wrapper.addClass('error');
        $wrapper.removeClass('success');
      } else if (data.result === 'success') {
        $errorHolder.hide().empty();
        $successHolder.show().html(data.msg);
        $successMessage.html(data.msg);
        $wrapper.removeClass('error');
        $wrapper.addClass('success');
        $successBody.addClass('hide');
        $successActionsSubmit.addClass('hide');
        $successActionsClose.addClass('show');

        popupSubscribe
          .querySelector('.js-modal-content-second')
          .classList.add('is-finalized');
      }
    });
  } else {
    if (firstStep) {
      return;
    }

    var errorMessage = '';

    if ($mailErrorValue == 0) {
      var errorMessage =
        errorMessage + $mailError[0].getAttribute('data-validate-email');
    }
    $errorHolder.show().html(errorMessage);
  }
};
